import * as React from 'react';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Grid, Row, Col } from 'react-flexbox-grid';

import Input from '@inqool/uas-web-core/es/components/controls/Input';
import { withState } from 'recompose';

const View: React.SFC<any> = ({ handleSubmit, closeItem, fileName, setFileName }) => (
  <Grid fluid={true} style={{ overflow: 'auto' }}>
    <Row style={{ marginTop: 15 }}>
      <Col md={6}>
        <h4>Název souboru:</h4>
      </Col>
      <Col md={6}>
        <Input name="fileName" value={fileName} fullWidth={true} onChange={setFileName} />
      </Col>
    </Row>
    <Button
      label="Uložit"
      primary={true}
      style={{ margin: '15px 15px 15px 0' }}
      onClick={() => handleSubmit(fileName, closeItem)}
    />
    <Button label="Zrušit" style={{ margin: '15px 0' }} onClick={closeItem} />
  </Grid>
);

export default withState('fileName', 'setFileName', '')(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormDescriptionSaveAsFileForm.tsx